import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { CashReceiptImportModel } from 'src/app/models/imports/cash-receipt-import.model';
import { InvoiceCashReceiptRetentionImportModel } from 'src/app/models/imports/invoice-cash-receipt-retention-import.model';
import { WayToPayImportModel } from 'src/app/models/imports/way-to-pay-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { CashReceiptPrintModel } from 'src/app/models/print/wallet/cash-receipt-print.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { CashReceiptModel } from 'src/app/models/wallet/cash-receipt.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CashReceiptService {

  constructor(private _httpClient: HttpClient) { }

  annulCashReceipt(cashReceiptId: number): Observable<CashReceiptModel> {
    return this._httpClient.put<CashReceiptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceipt.AnnulCashReceipt}/${cashReceiptId}`,
      null);
  }

  createCashReceipt(cashReceiptContract: CashReceiptModel): Observable<CashReceiptModel> {
    return this._httpClient.post<CashReceiptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceipt.CreateCashReceipt}`,
      cashReceiptContract);
  }

  deleteCashReceipt(cashReceiptId: number): Observable<CashReceiptModel> {
    return this._httpClient.delete<CashReceiptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceipt.DeleteCashReceipt}/${cashReceiptId}`);
  }

  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceipt.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  downloadGuideImportWayToPay(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceipt.DownloadGuideImportWayToPay}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  downloadGuideImportRetentions(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceipt.DownloadGuideImportRetentions}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  exportGeneralConsultation(isChargeAccount: boolean, filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceipt.ExportGeneralConsultation}/${isChargeAccount}`, filters, {
      params, responseType: 'blob',
    });
  }

  exportImportErrors(alerts: PreInvoicingAlertModel[]): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceipt.ExportImportErrors}`, alerts,
      {
        responseType: 'blob'
      }
    );
  }

  importCashReceipts(invoicesImport: Array<CashReceiptImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceipt.ImportChasReceipts}`, invoicesImport);
  }

  importRetentions(retentionsImport: Array<InvoiceCashReceiptRetentionImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceipt.ImportRetentions}`, retentionsImport);
  }

  importWayToPay(wayToPayImport: Array<WayToPayImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceipt.ImportWayToPay}`, wayToPayImport);
  }

  getAllCashReceiptsWithPagination(isChargeAccount: boolean, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceipt.GetAllCashReceiptsWithPaginationAsync}/${isChargeAccount}`,
      filters, { params: params }
    );
  }

  getAllClientsForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceipt.GetAllClientsForSelectAsync}`,);
  }

  getAllIncomeConceptsForSelectAsync(branchId: number): Observable<Array<any>> {
    const params = new HttpParams().set('branchId', branchId)
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceipt.GetAllIncomeConceptsForSelectAsync}`,
      { params: params }
    );
  }

  getCashReceiptById(cashReceiptId: number): Observable<CashReceiptModel> {
    return this._httpClient.get<CashReceiptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceipt.GetCashReceiptById}/${cashReceiptId}`);
  }

  getCashReceiptByKeysAsync(branchId: number, enterpriseId: number, consecutive: number, isChargeAccount: boolean): Observable<CashReceiptModel> {
    return this._httpClient.get<CashReceiptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceipt.GetCashReceiptByKeys}/${branchId}/${enterpriseId}/${consecutive}/${isChargeAccount}`);
  }

  getCashReceiptsByKeysByPrintAsync(branchId: number, enterpriseId: number, isChargeAccount: boolean, consecutiveInitial: number, consecutiveFinal: number): Observable<Array<CashReceiptPrintModel>> {
    return this._httpClient.get<Array<CashReceiptPrintModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceipt.GetCashReceiptsByKeysByPrintAsync}/${branchId}/${enterpriseId}/${isChargeAccount}/${consecutiveInitial}/${consecutiveFinal}`);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceipt.GetColumnsForGeneralConsultationAsync}`);
  }

  getEmptyCashReceiptPrint(): Observable<Array<CashReceiptPrintModel>> {
    return this._httpClient.get<Array<CashReceiptPrintModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceipt.GetEmptyCashReceiptPrint}`);
  }

  getFirstCashReceiptByKeysAsync(branchId: number, enterpriseId: number, isChargeAccount: boolean): Observable<CashReceiptModel> {
    return this._httpClient.get<CashReceiptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceipt.GetFirstCashReceiptByKeys}/${branchId}/${enterpriseId}/${isChargeAccount}`);
  }

  getLastCashReceiptByKeysAsync(branchId: number, enterpriseId: number, isChargeAccount: boolean): Observable<CashReceiptModel> {
    return this._httpClient.get<CashReceiptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceipt.GetLastCashReceiptByKeys}/${branchId}/${enterpriseId}/${isChargeAccount}`);
  }

  getNextCashReceiptByKeysAsync(branchId: number, enterpriseId: number, consecutive: number, isChargeAccount: boolean): Observable<CashReceiptModel> {
    return this._httpClient.get<CashReceiptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceipt.GetNextCashReceiptByKeys}/${branchId}/${enterpriseId}/${consecutive}/${isChargeAccount}`);
  }

  getPermissionPrint(): Observable<boolean> {
    return this._httpClient.get<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceipt.GetPermissionPrint}`);
  }

  getPreviusCashReceiptByKeysAsync(branchId: number, enterpriseId: number, consecutive: number, isChargeAccount: boolean): Observable<CashReceiptModel> {
    return this._httpClient.get<CashReceiptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceipt.GetPreviusCashReceiptByKeys}/${branchId}/${enterpriseId}/${consecutive}/${isChargeAccount}`);
  }

  setStateCashReceipt(cashReceiptId: number): Observable<CashReceiptModel> {
    return this._httpClient.put<CashReceiptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceipt.SetCashReceiptState}/${cashReceiptId}`,
      null);
  }

  updateCashReceipt(cashReceiptContract: CashReceiptModel): Observable<CashReceiptModel> {
    return this._httpClient.put<CashReceiptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceipt.UpdateCashReceipt}`,
      cashReceiptContract);
  }

  validateCountCashReceiptOpen(branchId: number, isChargeAccount: boolean): Observable<Array<number>> {
    return this._httpClient.get<Array<number>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceipt.ValidateCountCashReceiptsOpen}/${branchId}/${isChargeAccount}`);
  }

}
